import { Period } from '../../Interface/Interest/Period';

export enum PeriodType {
    PeriodsLoaded = 'periodsLoaded',
}

export interface PeriodsLoadedAction {
    type: PeriodType.PeriodsLoaded;
    periods: Period[];
}

export const periodsLoaded = (periods: Period[]): PeriodsLoadedAction => ({
    type: PeriodType.PeriodsLoaded,
    periods,
});

export type PeriodActionsType = PeriodsLoadedAction;
